
import { getCurrentConference } from '../base/conference';
import { setActiveModalId } from '../base/modal';
import { PARTICIPANT_KICKED, PARTICIPANT_LEFT } from '../base/participants';
import { MiddlewareRegistry, StateListenerRegistry } from '../base/redux';

import { TOGGLE_GENERICIFRAME_VISIBILITY } from './actionTypes';
import {
    checkParticipant,
    setGenericIFrameUrl,
    setGenericIFrameVisibilityState
} from './actions';
import { SHARE_GENERICIFRAME_VIEW_ID } from './constants';

const GENERICIFRAME_COMMAND = 'genericiframe';

/**
 * Middleware that captures actions related to collaborative document editing
 * and notifies components not hooked into redux.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */

MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    switch (action.type) {

    case TOGGLE_GENERICIFRAME_VISIBILITY: {
        const state = getState();
        const visible = !state['features/genericiframe'].visible;

        dispatch(setGenericIFrameVisibilityState(visible));

        // For native apps, also handle modal visibility
        if (typeof APP === 'undefined') {
            if (visible) {
                dispatch(setActiveModalId(SHARE_GENERICIFRAME_VIEW_ID));
            } else if (
                state['features/base/modal'].activeModalId === SHARE_GENERICIFRAME_VIEW_ID
            ) {
                dispatch(setActiveModalId(undefined));
            }
        }
        break;
    }

    case PARTICIPANT_LEFT: {
        const state = getState();
        const genericIframeState = state['features/genericiframe'];

        // Early exit: only process if genericiframe is currently visible
        if (!genericIframeState?.visible) {
            break;
        }

        const leftParticipantId = action?.participant?.id;

        // If the participant who was sharing the genericiframe left, reset the state
        if (leftParticipantId && genericIframeState?.partId === leftParticipantId) {
            dispatch(setGenericIFrameVisibilityState(false));
            dispatch(checkParticipant(null));

            // dispatch(setGenericIFrameUrl(undefined));
            // dispatch(checkParticipant(null));
            // dispatch(setShareMenuVisible(false));

            // Close modal if open
            if (typeof APP === 'undefined' && state['features/base/modal']?.activeModalId === SHARE_GENERICIFRAME_VIEW_ID) {
                dispatch(setActiveModalId(undefined));
            }
        }
        break;
    }

    case PARTICIPANT_KICKED: {
        const state = getState();
        const genericIframeState = state['features/genericiframe'];

        // Early exit: only process if genericiframe is currently visible
        if (!genericIframeState?.visible) {
            break;
        }

        const kickedParticipantId = action?.kicked;

        // If the participant who was sharing the genericiframe was kicked, reset the state
        if (kickedParticipantId && genericIframeState?.partId === kickedParticipantId) {
            dispatch(setGenericIFrameVisibilityState(false));
            dispatch(checkParticipant(null));

            // dispatch(setGenericIFrameUrl(undefined));
            // dispatch(setShareMenuVisible(false));

            // Close modal if open
            if (typeof APP === 'undefined' && state['features/base/modal']?.activeModalId === SHARE_GENERICIFRAME_VIEW_ID) {
                dispatch(setActiveModalId(undefined));
            }
        }
        break;
    }
    }

    return next(action);
});

/**
 * Set up state change listener to perform maintenance tasks when the conference
 * is left or failed, e.g. Clear messages or close the chat modal if it's left
 * open.
 */
StateListenerRegistry.register(
    state => getCurrentConference(state),
    (conference, { dispatch, getState }, previousConference) => {
        if (conference) {
            conference.addCommandListener(
                GENERICIFRAME_COMMAND,
                ({ value }) => {
                    let url;

                    const {
                        genericIFrameTemplateUrl
                    } = getState()['features/base/config'];

                    if (genericIFrameTemplateUrl) {
                        const u = new URL(value, genericIFrameTemplateUrl);

                        url = u.toString();
                    }

                    dispatch(setGenericIFrameUrl(url));

                }
            );
        }

        if (previousConference) {
            dispatch(setGenericIFrameUrl(undefined));
        }
    }
);


